import { z } from 'zod';

/**
 * Projektcheckliste (PM-App-Integration Phase A, ADR 0050): Punkte je Kategorie,
 * initialisierbar aus der Standard-Checkliste. Je nach Punkt JA/NEIN-Toggle
 * und/oder Datum + Zeichen (Benutzer-Kürzel); „Zukauf" trägt Lieferant/Prozess.
 */

export const createChecklistItemSchema = z.object({
  category: z.string().trim().min(1).max(120),
  title: z.string().trim().min(1).max(300),
  note: z.string().trim().max(500).optional(),
  hasYesNo: z.boolean().default(false),
  supplierNote: z.string().trim().max(200).optional(),
});
export type CreateChecklistItemInput = z.infer<typeof createChecklistItemSchema>;

export const updateChecklistItemSchema = z.object({
  title: z.string().trim().min(1).max(300).optional(),
  note: z.string().trim().max(500).nullable().optional(),
  /** JA/NEIN-Toggle; null setzt auf „unberührt" zurück. */
  isYes: z.boolean().nullable().optional(),
  supplierNote: z.string().trim().max(200).nullable().optional(),
  /** ISO-Datum (YYYY-MM-DD) oder null; leer beim JA-Setzen → Server stempelt heute. */
  completedAt: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
  /** Zeichen (Kürzel); leer beim Erledigen → Server stempelt das eigene Kürzel. */
  signedInitials: z.string().trim().max(8).nullable().optional(),
});
export type UpdateChecklistItemInput = z.infer<typeof updateChecklistItemSchema>;

export const reorderChecklistItemsSchema = z.object({
  /** Vollständige Reihenfolge innerhalb EINER Kategorie. */
  category: z.string().trim().min(1).max(120),
  orderedIds: z.array(z.string().uuid()).min(1).max(1000),
});
export type ReorderChecklistItemsInput = z.infer<typeof reorderChecklistItemsSchema>;

export const checklistItemResponseSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  category: z.string(),
  title: z.string(),
  note: z.string().nullable(),
  hasYesNo: z.boolean(),
  isYes: z.boolean().nullable(),
  supplierNote: z.string().nullable(),
  completedAt: z.string().nullable(),
  signedInitials: z.string().nullable(),
  position: z.number().int(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type ChecklistItemResponse = z.infer<typeof checklistItemResponseSchema>;

// ── Vorlage „Standard-Checkliste" (Admin) ────────────────────────────────────
export const checklistTemplateItemSchema = z.object({
  id: z.string().uuid(),
  category: z.string(),
  title: z.string(),
  note: z.string().nullable(),
  hasYesNo: z.boolean(),
  position: z.number().int(),
  isActive: z.boolean(),
});
export type ChecklistTemplateItem = z.infer<typeof checklistTemplateItemSchema>;
